import { IconPropsType } from '..';

export const OverviewIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="14"
    height="12"
    viewBox="0 0 14 12"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M3.80001 3.1999H0.600006V0.399902H3.80001V3.1999ZM13.4 0.399902H5.00001V4.3999H13.4V0.399902ZM3.80001 4.3999H0.600006V7.5999H3.80001V4.3999ZM3.80001 8.7999H0.600006V11.5999H3.80001V8.7999ZM13.4 5.5999H5.00001V11.5999H13.4V5.5999Z" />
  </svg>
);
